import { EmotionalArc } from '../types/story';


export const EMOTIONAL_ARCS: EmotionalArc[] = [
  {
    code: 'rags_to_riches',
    name: 'Rags to Riches',
    shape: 'Rise',
    emotionalJourney: 'hope → growth → elation',
    description: 'low state to triumph — Rocky, Erin Brockovich',
  },
  {
    code: 'riches_to_rags',
    name: 'Riches to Rags (Tragedy)',
    shape: 'Fall',
    emotionalJourney: 'comfort → cracks → despair',
    description: 'high to collapse — Macbeth, Requiem for a Dream',
  },
  {
    code: 'man_in_a_hole',
    name: 'Man in a Hole',
    shape: 'Fall → Rise',
    emotionalJourney: 'security → fall → breakthrough',
    description: 'struggle then stronger — Pursuit of Happyness, Cast Away',
  },
  {
    code: 'icarus',
    name: 'Icarus',
    shape: 'Rise → Fall',
    emotionalJourney: 'triumph → hubris → downfall',
    description: 'fast rise then crash — Wolf of Wall Street, Whiplash',
  },
  {
    code: 'cinderella',
    name: 'Cinderella',
    shape: 'Rise → Fall → Rise',
    emotionalJourney: 'joy → loss → renewal',
    description: 'uplift, setback, redemption — Cinderella, Slumdog Millionaire',
  },
  {
    code: 'heros_journey',
    name: 'Hero\'s Journey',
    shape: 'Return Changed',
    emotionalJourney: 'call → hardship → enlightenment → reintegration',
    description: 'transformation cycle — LOTR, Lion King',
  },
  {
    code: 'double_rise',
    name: 'Double Rise',
    shape: 'Rise → Rise Again',
    emotionalJourney: 'confidence → challenge → triumph',
    description: 'growth then stronger success — Hidden Figures, Moneyball',
  },
  {
    code: 'double_fall',
    name: 'Double Fall',
    shape: 'Fall → Fall Again',
    emotionalJourney: 'tension → dread → devastation',
    description: 'bad to worse — Manchester by the Sea, Leaving Las Vegas',
  },
  {
    code: 'transformation_through_surrender',
    name: 'Transformation Through Surrender',
    shape: 'Collapse → Acceptance → Empowerment',
    emotionalJourney: 'control → failure → surrender → strength',
    description: 'The Moment of Truth, Good Will Hunting',
  },
  {
    code: 'static_shift',
    name: 'Static Shift',
    shape: 'Internal Change Only',
    emotionalJourney: 'resistance → realization → new lens',
    description: 'world unchanged, perception shifts — Lost in Translation, Nomadland',
  },
];
